import { render, staticRenderFns } from "./PosterMyWallOauthStepTwo.vue?vue&type=template&id=8fc80dfc&scoped=true"
import script from "./PosterMyWallOauthStepTwo.vue?vue&type=script&lang=js"
export * from "./PosterMyWallOauthStepTwo.vue?vue&type=script&lang=js"
import style0 from "./PosterMyWallOauthStepTwo.vue?vue&type=style&index=0&id=8fc80dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc80dfc",
  null
  
)

export default component.exports